<template>
    <vx-card id="loader">
        <vs-row vs-w="12">
            <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                <div class="vx-row header-title mb-4">
                    <h1>Список категорий тегов объявлений</h1>
                </div>
            </vs-col>
        </vs-row>

        <div class="vx-row header-title ml-1 mt-3 mb-2">
            <h4>Фильтры</h4>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-2/3">
                <div class="mt-1">
                    <vs-input
                        v-model="form.name"
                        autocomplete="off"
                        v-on:keyup.enter="loadAdTagCategories()"
                        label="По названию"
                        class="mt-1 w-full"
                    />
                </div>
            </div>
            <div class="pt-2">
                <vx-tooltip text="Очистить список" position="top" delay=".3s">
                    <feather-icon icon="XIcon" @click="form.name = ''" class="inline-block text-danger cursor-pointer" svgClasses="w-5 h-5" />
                </vx-tooltip>
            </div>
        </div>

        <div class="vx-row mt-1">
            <div class="vx-col w-5/6 mb-1">
                <div class="mt-1">
                    <vs-button class="mt-2" color="success" @click="loadAdTagCategories()" type="filled"> Применить </vs-button>
                    <vs-button class="ml-5" color="rgb(250, 130, 80)" @click="createAdTagCatogory()" type="filled">
                        Добавить категорию тегов
                    </vs-button>
                </div>
            </div>

            <div class="vx-col w-1/6 mb-1">
                <div class="mt-1 pt-3">
                    <v-select
                        :options="dicts.pageSizes"
                        label="name"
                        placeholder="На странице..."
                        class="ml-1 page-size inline-block"
                        v-model="pageSize"
                        :clearable="false"
                        @input="loadAdTagCategories()"
                    >
                    </v-select>
                </div>
            </div>
        </div>

        <vs-table v-model="selected" :data="adTagCategories" max-items="10" class="mt-5">
            <template slot="thead">
                <vs-th> Id </vs-th>
                <vs-th> Обязательная </vs-th>
                <vs-th> Название категории </vs-th>
                <vs-th> Действия </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.id }}</vs-td>
                    <vs-td>
                        <vs-checkbox disabled icon="check" color="rgb(38, 187, 174)" v-model="tr.required" />                            
                    </vs-td>
                    <vs-td>{{ tr.name }}</vs-td>
                    <vs-td>
                        <!--TODO Add opening tags list for this category-->
                        <div class="inline-block">
                            <router-link :to="{ name: 'adTagCategory-edit', params: { id: tr.id } }">
                                <vx-tooltip text="Редактировать категорию" position="top" delay=".3s">
                                    <feather-icon icon="Edit2Icon" class="inline-block mr-2" svgClasses="w-7 h-7" />
                                </vx-tooltip>
                            </router-link>
                        </div>
                        <div class="inline-block cursor-pointer">
                            <vx-tooltip text="Удалить категорию тегов" position="top" delay=".3s">
                                <feather-icon
                                    @click="showDeleteModal(tr)"
                                    icon="XCircleIcon"
                                    class="inline-block mr-2 text-danger"
                                    svgClasses="w-7 h-7"
                                />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-pagination :max="25" :total="pagesTotal" v-model="page"></vs-pagination>

        <sweet-modal ref="deleteModal" icon="error" title="Удаление тега">
            <div class="mb-5">Вы действительно хотите удалить категорию '{{ selected.name }}'?</div>

            <vs-button class="" color="danger" @click="deleteAdTagCategory(selected)" type="filled"> Удалить тег </vs-button>
        </sweet-modal>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';

export default {
    name: 'adTagCategories',
    data() {
        return {
            adTagCategories: [],
            selected: {},
            form: {
                allSelected: false,
                name: '',
                adTagCategories: undefined,
                showDeleted: false
            },
            errors: {
                name: '',
                status: null
            },
            dicts: {
                pageSizes: [5, 25, 50, 100, 500]
            },

            page: 1,
            pageSize: 50,
            pagesTotal: 1
        };
    },
    components: {
        vSelect,
        SweetModal,
        SweetModalTab
    },
    methods: {
        loadAdTagCategories() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                searchPattern: this.form.name,
                page: this.page,
                size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('adTagCategories', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    }),
                    this.axios.get('adTagCategories/count', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    })
                ])
                .then(
                    axios.spread((adTagCategories, count) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.adTagCategories = adTagCategories.data;
                        this.pagesTotal = Math.ceil(count.data / this.pageSize);
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки тегов объявлений.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        showDeleteModal(adTagCategory) {
            this.selected = adTagCategory;
            this.$refs.deleteModal.open();
        },
        deleteAdTagCategory(adTagCategory) {
            this.$axios({
                method: 'DELETE',
                url: 'adTagCategories/' + adTagCategory.id,
                errors: this.errors,
                success: () => {
                    this.adTagCategories = this.adTagCategories.filter((c) => c.id != adTagCategory.id);
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно удалено',
                        text: 'Категория тегов успешно удалена',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Ошибка при удалении!',
                        text: err.response.data,                        
                        color: 'danger'
                    });
                }
            });
        },
        createAdTagCatogory() {
            this.$router.push('/content-quality/ad-tag-categories/create');
        },
        selectAll() {
            this.adTagCategories.forEach((adTagCategory) => {
                adTagCategory.changemany = !this.form.allSelected;
            });
        }
    },
    watch: {
        page: function () {
            this.loadAdTagCategories();
        }
    },
    mounted() {
        this.loadAdTagCategories();
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}

.header-title {
    flex-direction: column;
}

.textarea {
    border: 1px solid lightgrey !important;
    background-color: RGB(245, 245, 245);
}
</style>